import { showError } from './utils';
import axios from 'axios';

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER ? process.env.REACT_APP_SERVER : '',
});

// 添加请求拦截器，自动设置 Accept-Language 请求头
API.interceptors.request.use(
  (config) => {
    // 从 localStorage 获取当前语言
    const currentLang = localStorage.getItem('i18nextLng') || 'zh';
    // 设置 Accept-Language 请求头
    config.headers['Accept-Language'] = currentLang === 'en' ? 'en' : 'zh-CN';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    showError(error);
  }
);
